import PropTypes from "prop-types"
import { Controller } from "react-hook-form"

import FloatInput from "components/ui/float-input"

const GiftCardDate = ({ arrowColor, control }) => {
  return (
    <Controller
      control={control}
      name="email_send_date"
      render={({ field, fieldState: { error } }) => (
        <FloatInput
          arrowColor={arrowColor}
          error={error}
          id={name}
          label="Send Date"
          min={new Date().toISOString().slice(0, 10)}
          pattern="(?:19|20)[0-9]{2}-(?:(?:0[1-9]|1[0-2])-(?:0[1-9]|1[0-9]|2[0-9])|(?:(?!02)(?:0[1-9]|1[0-2])-(?:30))|(?:(?:0[13578]|1[02])-31))"
          type="date"
          {...field}
        />
      )}
    />
  )
}

GiftCardDate.propTypes = {
  arrowColor: PropTypes.string,
  control: PropTypes.object,
  id: PropTypes.string,
}

export default GiftCardDate
